// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Button_blockWrapper__KeZhM","content":"Button_content__Te8Q2","image":"Button_image__tZk8m"};